
export type TweetResponseMediaItemType = typeof TweetResponseMediaItemType[keyof typeof TweetResponseMediaItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetResponseMediaItemType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
} as const;
